import { render, staticRenderFns } from "./course_notpay.vue?vue&type=template&id=460ebc6e&scoped=true"
import script from "./course_notpay.vue?vue&type=script&lang=js"
export * from "./course_notpay.vue?vue&type=script&lang=js"
import style0 from "./course_notpay.vue?vue&type=style&index=0&id=460ebc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460ebc6e",
  null
  
)

export default component.exports